export default __webpack_public_path__ + "static/media/003-namaste.490b6bd8.svg";